import { isSessionValid } from "../../utils/sessionUtils";

export const getAuthToken = (state) => state?.auth?.token;
export const getUserIsLoggedInSelector = (state) => {
  const token = state?.auth?.token;
  if (!token) return false;

  return isSessionValid(); 
};
export const getUserDataSelelctor = (state) => state?.auth?.userData;
export const getAppLanguageSelector = (state) => state?.auth?.appLanguage;
